module.exports = __webpack_public_path__ + "img/128.38f07131.jpg";